module.exports = __webpack_public_path__ + "static/media/03.3676a84b.png";